@let vm =
    {
        isTrainRequested: isTrainRequested$ | async,
    };

<div id="trainTab" class="tab flex flex-col gap-medpace">
    @if (!isTrainAvailable()) {
        <medpace-alert [appearance]="'highlight'" [content]="nonAvailableMessage" />
    }
    @if (isTrainAvailable() || vm.isTrainRequested) {
        <medpace-needs-travel-radio-group
            [label]="'Will the patient need train travel?'"
            [isDisabled]="isLimitedService()"
            [isUpdate]="isUpdate()"
            [formCtrl]="formGroup().controls.needsTravel"
        />
        @if (formGroup().controls.needsTravel.value) {
            <div>
                <mds-divider />
                <mds-expansion-panel
                    class="expansion-panel-request !border-y-0"
                    [panelTitle]="'Train preferences'"
                    [description]="'(from Patient Profile)'"
                >
                    <medpace-train-preferences
                        [formGroup]="formGroup().controls.travel.controls.preferences"
                        [mode]="'view'"
                    />
                </mds-expansion-panel>
                <mds-divider />
            </div>
            <medpace-train-request-details
                [mode]="isLimitedService() ? 'view' : mode()"
                [formGroup]="formGroup().controls.travel.controls.requestDetails"
            />
        }
    }
</div>
